const displayWireTransferBlock = () => {
  let $wire_transfer_type = $('input[name="subscription[bank_account_info_attributes][wire_transfer_type]"]:checked');

  if ($wire_transfer_type.length == 0) {
    return ;
  }

  let wire_transfer_type_value = $wire_transfer_type.val().toLowerCase();
  let $wire_transfer_block = $('#' + wire_transfer_type_value + '-info');
  let $wire_transfer_blocks = $('.bank-wire-block');

  $wire_transfer_blocks.addClass('d-none');
  $('input', $wire_transfer_blocks).prop('disabled', true);

  if (wire_transfer_type_value.length) {
    $wire_transfer_block.removeClass('d-none');
    $('input', $wire_transfer_block).prop('disabled', false);
  }
};

$(document).ready(() => {
  if ($('input[name="subscription[bank_account_info_attributes][wire_transfer_type]"]').length) {
    $('input[name="subscription[bank_account_info_attributes][wire_transfer_type]"]').on('change', displayWireTransferBlock);

    displayWireTransferBlock();
  }
});
